import useRoles from "@/hooks/authentication/useAuthenticatedUser";
import { createContext } from "react";

interface IRolesContext extends ReturnType<typeof useRoles>{

}

const RolesContext = createContext<IRolesContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined
})

export default RolesContext;